<template>
  <div>
    <van-nav-bar
      :title="$t('app.withdraw_pass.title')"
      :left-text="$t('app.common.back')"
      left-arrow
      onclick="window.history.go(-1)"
    />
    <van-form @submit="onSubmit">
      <van-field
        v-model="user.phone"
        name="phone"
        :label="$t('app.withdraw_pass.phone')"
        :placeholder="$t('app.withdraw_pass.phone')"
        readonly
      />
      <van-field
        v-model="rePicCode"
        center
        clearable
        :label="$t('app.withdraw_pass.verification')"
        :placeholder="$t('app.withdraw_pass.verification_placeholder')"
      >
        <div slot="button">
          <img
            :src="captcha"
            @click="this.getCaptcha"
            style="height: 25px; width: 80px"
          />
        </div>
      </van-field>
      <van-field
        v-model="sms"
        center
        clearable
        :label="$t('app.withdraw_pass.sms_verification')"
        :placeholder="$t('app.withdraw_pass.sms_verification_placeholder')"
        :rules="[{ required: true, message: this.$t('app.withdraw_pass.sms_verification_dsc') }]"
      >
        <template #button>
          <van-button native-type="button" size="small" plain type="info" @click="getPayCode" :disabled="disabled">{{getCodeText}}</van-button>
        </template>
      </van-field>
      <van-field
        v-model="payPass"
        type="password"
        name="loginPass"
        :label="$t('app.withdraw_pass.withdraw_pass')"
        :placeholder="$t('app.withdraw_pass.withdraw_pass')"
        :rules="[{ required: true, message: this.$t('app.withdraw_pass.withdraw_pass_dsc') }]"
      />
      <van-field
        v-model="confirmPass"
        type="password"
        name="confirmPass"
        :label="$t('app.withdraw_pass.confirm_pass')"
        :placeholder="$t('app.withdraw_pass.confirm_pass')"
        :rules="[{ required: true, message: this.$t('app.withdraw_pass.confirm_pass_dsc') }]"
      />
      <div style="margin: 16px;">
        <van-button round block type="danger" size="small" native-type="submit">
          {{$t("app.common.sure")}}
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import JSEncrypt from "jsencrypt/bin/jsencrypt";
    export default {
      name: "WithdrawalPass",
      data(){
        return{
          sms:'',
          payPass:'',
          confirmPass:'',
          disabled:false,
          getCodeText: this.$t('app.withdraw_pass.get_code'),
          captcha: "",
          rePicCode: "",
          verify_token: "",
        }
      },
      computed:{
        phone:function () {
          return this.$store.state.phone
        },
        user:function () {
          return this.$store.state.user
        }
      },
      methods:{
        isLogin(){
          let that = this;
          if (!that.$store.state.loginType){
            that.$router.push('/login')
          }
        },
        onSubmit(){
          let that = this;
          if (that.payPass === that.confirmPass){
            let publicKey = localStorage.getItem("encript_public_key");
            let loginPassword = that.encryptMessage(that.payPass, publicKey);
            let confirmPassword = that.encryptMessage(that.confirmPass, publicKey);
            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "modify_pay_e",
                  token: sessionStorage.getItem("token"),
                  password: loginPassword,
                  confirm: confirmPassword,
                  code: that.sms
                }
              })
              .then(function(res) {
                if (res.data.code == 1) {
                  that.$toast.success({
                    message: res.data.msg,
                    onClose:function () {
                      that.$router.push({
                        path: "/member/information"
                      });
                    }
                  });
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$toast.fail(that.$t(res.data.msg));
                }
              });
          }else{
            that.$toast.fail(this.$t('app.withdrawalpass.password_not_identical'));
          }
        },
        getPayCode() {
          let that = this;
          clearInterval(window.timer2);
          let publicKey = localStorage.getItem("encript_public_key");
          let userPhone = this.$store.state.phone.toString();
          let inputPhone = that.encryptMessage(userPhone, publicKey);
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "modifyInfo_code_e",
                info: inputPhone,
                type: 1,
                rePicCode: that.rePicCode,
                verify_token: that.verify_token,
              }
            })
            .then(function(res) {
              if (res.data.code == 1) {
                that.$toast.success({
                  message: res.data.msg,
                });
                var time = 60;
                that.disabled = true;
                that.getCodeText = time + "s";
                window.timer2 = setInterval(function() {
                  time--;
                  that.getCodeText = time + "s";
                  if (time <= 0) {
                    clearInterval(window.timer2);
                    that.disabled = false;
                    that.getCodeText = "获取验证码";
                  }
                }, 1000);
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$toast.fail(that.$t(res.data.msg));
              }
            });
        },
        encryptMessage(message, publicKey) {
          const jsEncrypt = new JSEncrypt();
          jsEncrypt.setPublicKey(publicKey);
          return jsEncrypt.encrypt(message);
        },
        getCaptcha() {
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "getSmsPic",
              },
            })
            .then(function (res) {
              let resData = res.data;
              if (resData.code == 1) {
                that.captcha = resData.data.code_url;
                that.verify_token = resData.data.verify_token;
              } else if (resData.code == 0) {
                that.disabled = false;
                that.$toast.fail(that.$t(res.data.msg));
              }
            });
        },
      },
      
      mounted:function () {
        this.getCaptcha();
        this.isLogin();
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/WithdrawalPass.vue